// extracted by mini-css-extract-plugin
export default {"ruler":"ScaleRuler_ruler__PilZf"};